import { GetRowIdParams } from 'ag-grid-enterprise'
import { Pencil, Trash2 } from 'lucide-react'
import { renderToString } from 'react-dom/server'

import { CustomAgGrid, createContextMenu, getBasicColDefsFromData } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { MarketSummary } from '@fortem-monorepo/web-sdk'

import { useMarketSummaryActions } from '@/pages/instruments/market-summary/market-summary-actions'
import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

export interface MarketSummaryInstrumentsTabProps {}

export const MarketSummaryInstrumentsTab: React.FC<MarketSummaryInstrumentsTabProps> = () => {
  const { instrumentsQuery, hasWriteAccess } = useMarketSummaryContext()

  const { removeInstrument, updateInstrument, actionState } = useMarketSummaryActions()

  const contextMenu = createContextMenu<MarketSummary.Instrument>((params) => {
    const row = params.node?.data
    const defaults = params.defaultItems ?? []
    if (!row || params.node?.group) return defaults

    return [
      ...(hasWriteAccess
        ? [
            {
              name: 'Update Instrument',
              icon: renderToString(<Pencil size={16} />),
              disabled: actionState !== null,
              action: () => updateInstrument({ instrument_id: row.instrument_id }),
            },
            {
              name: 'Remove Instrument',
              icon: renderToString(<Trash2 size={16} />),
              cssClasses: ['text-red-600!'],
              disabled: actionState !== null,
              action: () => removeInstrument({ instrument_id: row.instrument_id }),
            },
            'separator',
          ]
        : ([] as any)),
      ...defaults,
    ]
  })

  return (
    <div className={'flex-1 h-full'}>
      <Widget exposed className={'h-full'}>
        <WidgetHeaderWithQuery query={instrumentsQuery} title="Instruments" />
        <WidgetContent loading={instrumentsQuery.isLoading}>
          <CustomAgGrid
            getContextMenuItems={contextMenu}
            rowData={instrumentsQuery.data}
            getRowId={(row: GetRowIdParams<MarketSummary.Instrument>) => row.data.instrument_id.toString()}
            query={instrumentsQuery}
            columnDefs={getBasicColDefsFromData(instrumentsQuery.data ?? [])}
            domLayout={'normal'}
          />
        </WidgetContent>
      </Widget>
    </div>
  )
}
